// import React from "react";
// import { Box, Typography, Grid, TextField, Paper } from "@mui/material";

// const CashFeeReceipt = () => {
//   return (
//     <Box
//       display="flex"
//       justifyContent="center"
//       alignItems="center"
//       minHeight="100vh"
//       bgcolor="#f5f5f5"
//     >
//       <Paper
//         elevation={3}
//         sx={{
//           border: "6px solid #006400", // dark green border
//           padding: 4,
//           maxWidth: 800,
//           width: "100%",
//           backgroundColor: "#ffffff",
//         }}
//       >
//         {/* Header */}
//         <Grid container justifyContent="space-between" alignItems="center">
//           <Grid item>
//             <Typography
//               variant="h5"
//               align="center"
//               fontWeight="bold"
//               color="green"
//             >
//               CASH VOUCHER
//             </Typography>
//           </Grid>
//           <Grid item>
//             <Typography
//               variant="subtitle1"
//               align="right"
//               fontWeight="bold"
//               color="green"
//             >
//               RIDGE GREEN<br />CORPORATION
//             </Typography>
//           </Grid>
//         </Grid>

//         <Box
//           component="form"
//           sx={{
//             mt: 4,
//             border: "1px solid #000",
//           }}
//         >
//           {/* Transaction Type */}
//           <Box
//             sx={{
//               display: "flex",
//               borderBottom: "1px solid #000",
//             }}
//           >
//             <Box sx={{ width: 200, borderRight: "1px solid #000", p: 1 }}>
//               <Typography fontWeight="bold">Transaction Type:</Typography>
//             </Box>
//             <Box sx={{ flex: 1, p: 1 }}>
//               <TextField
//                 variant="standard"
//                 fullWidth
//                 InputProps={{ disableUnderline: true }}
//               />
//             </Box>
//           </Box>

//           {/* Amount */}
//           <Box
//             sx={{
//               display: "flex",
//               borderBottom: "1px solid #000",
//             }}
//           >
//             <Box sx={{ width: 200, borderRight: "1px solid #000", p: 1 }}>
//               <Typography fontWeight="bold">Amount:</Typography>
//             </Box>
//             <Box sx={{ flex: 1, p: 1 }}>
//               <TextField
//                 variant="standard"
//                 fullWidth
//                 InputProps={{ disableUnderline: true }}
//               />
//             </Box>
//           </Box>

//           {/* To */}
//           <Box
//             sx={{
//               display: "flex",
//               borderBottom: "1px solid #000",
//             }}
//           >
//             <Box sx={{ width: 200, borderRight: "1px solid #000", p: 1 }}>
//               <Typography fontWeight="bold">To:</Typography>
//             </Box>
//             <Box sx={{ flex: 1, p: 1 }}>
//               <TextField
//                 variant="standard"
//                 fullWidth
//                 InputProps={{ disableUnderline: true }}
//               />
//             </Box>
//           </Box>

//           {/* Blank space for details */}
//           <Box
//             sx={{
//               display: "flex",
//               borderBottom: "1px solid #000",
//               height: 100,
//             }}
//           >
//             <Box sx={{ flex: 1, borderRight: "1px solid #000" }}></Box>
//             <Box sx={{ flex: 1 }}></Box>
//           </Box>

//           {/* Approved By & Signature */}
//           <Box sx={{ display: "flex" }}>
//             <Box
//               sx={{
//                 flex: 1,
//                 borderRight: "1px solid #000",
//                 p: 1,
//                 display: "flex",
//                 alignItems: "center",
//               }}
//             >
//               <Typography fontWeight="bold">Approved By:</Typography>
//             </Box>
//             <Box sx={{ flex: 1, p: 1, display: "flex", alignItems: "center" }}>
//               <Typography fontWeight="bold">Signature:</Typography>
//             </Box>
//           </Box>
//         </Box>
//       </Paper>
//     </Box>
//   );
// };

// export default CashFeeReceipt;


import React from "react";
import {
  Box,
  Typography,
  Grid,
  TextField,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
} from "@mui/material";

const CashFeeReceipt = () => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      bgcolor="#f5f5f5"
      marginTop="5%"
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          maxWidth: 900,
          width: "100%",
          bgcolor: "#fffff0", // light beige like in image
        }}
      >
        {/* Title */}
        <Typography
          variant="h5"
          align="center"
          fontWeight="bold"
          gutterBottom
        >
          PETTY CASH RECEIPT
        </Typography>

        {/* Received from & Date */}
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item xs={8}>
            <Typography variant="body1">
              Received from: UNIVERSITY OF WEST GEORGIA CASHIER
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Box display="flex" alignItems="center">
              <Typography variant="body1" sx={{ mr: 1 }}>
                Date
              </Typography>
              <Box sx={{ borderBottom: "1px solid #000", flex: 1 }} />
            </Box>
          </Grid>
        </Grid>

        <Box mt={3}>
          <Typography variant="body1" gutterBottom>
            For the following:
          </Typography>

          {/* Table */}
          <TableContainer>
            <Table sx={{ border: "1px solid #000" }}>
              <TableHead>
                <TableRow sx={{ borderBottom: "1px solid #000" }}>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      borderRight: "1px solid #000",
                      width: "30%",
                    }}
                  >
                    VENDOR NAME
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      borderRight: "1px solid #000",
                      width: "50%",
                    }}
                  >
                    DESCRIPTION OF ITEMS PURCHASED
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      width: "20%",
                    }}
                  >
                    AMOUNT
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {[...Array(4)].map((_, idx) => (
                  <TableRow key={idx} sx={{ height: 50 }}>
                    <TableCell sx={{ borderRight: "1px solid #000" }} />
                    <TableCell sx={{ borderRight: "1px solid #000" }} />
                    <TableCell />
                  </TableRow>
                ))}
                {/* Total Row */}
                <TableRow>
                  <TableCell
                    colSpan={2}
                    sx={{ borderTop: "1px solid #000", fontWeight: "bold" }}
                  >
                    TOTAL
                  </TableCell>
                  <TableCell
                    sx={{
                      borderTop: "1px solid #000",
                      fontWeight: "bold",
                      textAlign: "right",
                    }}
                  >
                    $0.00
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

        {/* Account and Approval Details */}
        <Grid container spacing={3} mt={3}>
          <Grid item xs={6}>
            <Typography variant="body2">Account Name _________________________________</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2">Signature of Purchaser ________________________</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2">Account # ____________________________________</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2">Departmental Approval ________________________</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2">
              Approved ___________________________________ <br />
              <em>Office of Business Services</em>
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2">
              _________________________________________ <br />
              <em>CASH RECIPIENT (To be signed at cashier's window)</em>
            </Typography>
          </Grid>
        </Grid>

        {/* Note */}
        <Box mt={2}>
          <Typography variant="caption" display="block">
            * Attach original paid receipts to back of voucher
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
};

export default CashFeeReceipt;
